import { Grid, Stack } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

type ContentLayoutProps = {
  children?: ReactNode;
  sidebar?: ReactNode;
};

export const ContentLayout: FC<ContentLayoutProps> = ({ children, sidebar }) => {
  return (
    <Grid
      as="section"
      templateColumns={{ base: '1fr', lg: 'minmax(70%, 3fr) minmax(20rem, 30rem)' }}
      gap={4}
      gridTemplateAreas={'"content sidebar"'}
      m={6}
    >
      <Stack gridArea={'content'} gridColumnEnd={!sidebar ? '-1' : ''} spacing={{ base: '8', lg: '6' }}>
        {children}
      </Stack>
      {sidebar && (
        <Stack gridArea={'sidebar'} spacing={{ base: '8', lg: '6' }}>
          {sidebar}
        </Stack>
      )}
    </Grid>
  );
};
